import { useEffect } from "react";
import { Spinner } from "@opencloud/ui";
import type { AgentBootstrap } from "../bootstrap.js";
import { agentBrand } from "../brand.js";

export function SignInRedirect({ bootstrap }: { bootstrap: AgentBootstrap }) {
  useEffect(() => {
    const login = new URL(bootstrap.signInUrl, window.location.href);
    login.searchParams.set("return_to", window.location.href);
    window.location.replace(login.toString());
  }, [bootstrap.signInUrl]);

  const { productName } = agentBrand();
  return (
    <div className="a3-theme a3-loading-screen" role="status">
      <Spinner aria-label={`Opening ${productName} login`} />
      <span>{`Opening ${productName} login…`}</span>
    </div>
  );
}
